export default "__VITE_ASSET__BK78NERJ__"